angular.module('wbDashboard')
.controller('MilestoneModControllerAurea',
    ['$scope', '$q', '$window', '$location', '$filter', '$uibModal', '$timeout', '$templateCache', 'NgTableParams',
        'User', 'Milestone', 'RiskScore', 'PlanService', 'DataService', 'Message',
function ($scope, $q, $window, $location, $filter, $uibModal, $timeout, $templateCache, NgTableParams,
          User, Milestone, RiskScore, PlanService, DataService, Message) {

    $scope.pages = ['select'];



    /*jshint -W030 */
    $scope.forms || ($scope.forms = {});
    /*jshint +W030 */

    Milestone.clearMS();
    $scope.milestone = Milestone.ms;
    $scope.MS = Milestone;
    //state info for page
    $scope.pageData = {
        sending: false,
        creating: false,
        updating: false,
        errorMsg: null,
        percent: 0,
        typeClicked: null,
        navigating: false,
        view: {
            footer: true
        },
        positionHighlight: {
            on: {},
            off: {}
        },
        help: {}
    };

    //shared data for child states
    $scope.mod || ($scope.mod = {}); // jshint ignore:line
    angular.extend($scope.mod, {
        action: null,
        extra: {} //will be reset when child state changes
    });

    $scope.currentYear = new Date().getFullYear();

    $scope.cashAllocation = false;

    /**
     * Used to prevent ajax request of template if it's not in the cache
     */
    $scope.getTemplate = function(template) {
        if ($templateCache.get(template)) {
            return template;
        }
    };

    /**
     ******************************************
     * Allocation/Risk Related
     ******************************************
     */
    $scope.portfolio = {
        enabled: false,
        list: [],
        custom: null,
        selected: null,
        table: {}
    };

    DataService.retrieveAssetClasses();
    RiskScore.retrievePortfolios().then(function (data) {
        $scope.portfolio.coreList = angular.copy(data);
    });

    $scope.$watch(function() { return PlanService.user.getPortfolios(); }, function(portfolios) {

        if (portfolios) {
            $scope.portfolio.list.length = 0;
            angular.forEach(portfolios, function (p, key) {
                // PlanService.user.retrievePortfolioPositions(p.slug);
                $scope.portfolio.list.push(angular.copy(p));
            });
            $scope.portfolio.list.push(RiskScore.getCorePortfolio());
        } else {
            $scope.portfolio.list.length = 0;
            $scope.portfolio.list.push(RiskScore.getCorePortfolio());
        }


    }, true);

    $scope.viewPortfolioAllocation = function(slug, cash) {
        $scope.setPortfolioAllocationChart(slug, cash);
        $scope.openPortfolioAllocationModal();
    };

    $scope.setPortfolioAllocationChart = function(slug, cash = 0) {
        var portfolio;
        $scope.portfolio.selected = {};

        if (isNaN(slug)) {
            portfolio = PlanService.user.getPortfolios(slug);
        } else {
            portfolio = $scope.portfolio.coreList[slug.toFixed(1)];
        }

        if (portfolio) {

            portfolio = angular.copy(portfolio);
            portfolio = RiskScore.formatPortfolio(portfolio, cash, true);
            $scope.portfolio.table.params = RiskScore.getAssetTableParams(portfolio);

            $scope.portfolio.selected = portfolio;
        }
    };

    $scope.openPortfolioAllocationModal = function() {

        var $modalScope = $scope.$new();

        $modalScope.portfolio = $scope.portfolio;

        var modalInstance = $uibModal.open({
            templateUrl: "milestone-portfolio-allocation-modal.tpl.html",
            size: 'lg-head',
            scope: $modalScope,
            windowClass: 'milestone-pages portfolio-allocation-modal'
        });
        modalInstance.result.catch(angular.noop);
    };

    $scope.mod.initPortfolioType = function(type) {
        Milestone.updatePortfolioType(type);
    };

    /**
     ******************************************
     * Account Related
     ******************************************
     */


    /**
     ******************************************
     * Milestone Mod Related
     ******************************************
     */

    //needed for confirmation page date
    // $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
    //     $scope.autos = autos;
    // });

    /**
     */
    // $scope.$watch('milestone', function(milestone) {
    // }, true);

    $scope.$watchGroup(['milestone.extra.period_years','milestone.extra.period_months'], function(data) {
        var [years, months] = data;
        //keep != so also checks for undefined
        if (years != null && months != null) {
            Milestone.setDatesByMonthYear();
        }
    });
    $scope.$watch('milestone.extra.social_security_percent', function(percent) {
        //make sure percent is rounded to whole number
        if (percent || percent === 0) {
            percent = Math.floor(percent);
            $scope.milestone.extra.social_security_percent = percent;
            $scope.milestone.metadata.social_security_payout = percent / 100;
        } else if ($scope.milestone.type === 'retirement') {
            $scope.milestone.metadata.social_security_payout = null;
        }
    });
    $scope.$watch('milestone.extra.cash_percent', function(percent) {
        //make sure percent is rounded to whole number
        if (percent || percent === 0) {
            $scope.milestone.allocation.cash = percent/100;
        } else {
            $scope.milestone.allocation.cash = null;
        }
    });
    $scope.$watchGroup(['milestone.extra.cash_start_percent','milestone.extra.cash_end_percent'], function(data) {
        var [startPercent, endPercent] = data;

        if (startPercent || endPercent || endPercent === 0) {
            $scope.milestone.allocation.cash_start = getCashRatio(startPercent);
            $scope.milestone.allocation.cash_end = getCashRatio(endPercent);

            if ($scope.milestone.type === 'build_wealth' || $scope.milestone.type_account) {
                $scope.milestone.allocation.cash_end = $scope.milestone.allocation.cash_start;
            }

        }

        function getCashRatio(percent) {
            var ratio = null;
            //make sure percent is rounded to whole number
            if (percent || percent === 0) {
                ratio = percent / 100;
            }
            return ratio;
        }
    });
    $scope.$watch("milestone.extra.allocation_value", function(value) {
        if (value || value === 0) {
            if (!isNaN($scope.milestone.allocation.allocation_model) || !$scope.milestone.allocation.allocation_model) {
                if (value < 0.9) {
                    $scope.milestone.allocation.allocation_model = "0.0";
                } else {
                    $scope.milestone.allocation.allocation_model = value.toFixed(1);
                }
            }
        }
    });
    $scope.$watch('milestone.extra.portfolio_slug', function(slug) {
        if (slug) {
            if (slug === 'core') {
                if ($scope.milestone.allocation.recommendation) {
                    if (!$scope.milestone.allocation.allocation_start || $scope.milestone.allocation.allocation_start.length > 4) {
                        $scope.milestone.extra.allocation_start_value = $scope.milestone.allocation.recommendation.allocation_start*1;
                        $scope.milestone.allocation.allocation_start = $scope.milestone.allocation.recommendation.allocation_start;
                    }
                    if (!$scope.milestone.allocation.allocation_end || $scope.milestone.allocation.allocation_end.length > 4) {
                        $scope.milestone.extra.allocation_end_value = $scope.milestone.allocation.recommendation.allocation_end*1;
                        $scope.milestone.allocation.allocation_end = $scope.milestone.allocation.recommendation.allocation_end;
                    }
                }
            } else if (slug !== 'core') {
                $scope.portfolio.custom = PlanService.user.getPortfolios(slug);
                $scope.milestone.allocation.allocation_start = slug;
                $scope.milestone.allocation.allocation_end = slug;
            }
        }
    });
    $scope.$watchGroup(['milestone.extra.allocation_start_value','milestone.extra.allocation_end_value'], function(data) {
        var [startValue, endValue] = data;

        if (startValue || startValue === 0) {
            $scope.milestone.allocation.allocation_start = startValue.toFixed(1);
        }
        if (endValue || endValue === 0) {
            $scope.milestone.allocation.allocation_end = endValue.toFixed(1);
        }
    });

    $scope.$watch('milestone.auto_deposit.amount', function(autoAmount) {
        if ($scope.milestone.type_account) return;

        if ((autoAmount || autoAmount === 0) && $scope.$stateParams.page === "auto-deposit") {
            $scope.pageData.sending = true;
            Milestone.changedAutoDeposit().finally(function() {
                $scope.pageData.sending = false;
            });

        }
    });
    $scope.$watch('milestone.extra.account_type', function(type) {
        //should only be used on create milestone
        if (type) {
            if (!$scope.milestone.id) {

                //*strikeout* first account is always PIA
                var pia = {
                    account_number: null,
                    type: "personal-investment-account",
                    name: "Personal Account",
                    auto_deposit: null,
                    annual_deposit_limit: null,
                    initial_deposit: 0
                };

                var existingPIA = User.getOverviewAccounts("personal-investment-account");
                if (existingPIA && existingPIA.account_number) {
                    pia.account_number = existingPIA.account_number;
                }

                if (type !== "personal-investment-account") {
                    $scope.milestone.accounts[0] = {
                        account_number: null,
                        type: type,
                        name: type.replace('-', ' ').replace("Ira", "IRA").replace(/\b[a-z]/g, l => l.toUpperCase()),
                        auto_deposit: null,
                        annual_deposit_limit: null
                    };
                    
                    $scope.milestone.accounts[1] = pia;

                } else {
                    $scope.milestone.accounts[0] = pia;

                    //remove second account if there is one
                    $scope.milestone.accounts.splice(1,1);
                }
            }
        }
    });
    $scope.$watch('milestone.accounts', function(accounts, oldAccounts) {
        Milestone.updateAutoDepositRemaining();
        Milestone.fixRemainingAutodeposits(accounts, oldAccounts);
        Milestone.updateAnnualLimits();
    }, true);
    $scope.$watch("milestone.metadata.retirement_age", function(age) {
        if (age) { Milestone.updateRetirementAge(); }
    });
    $scope.$watch("milestone.metadata.life_expectancy", function(life) {
        if (life) { Milestone.getGlideRecommend($scope.milestone); }
    });

    //validation for year & month time selection
    $scope.notZeroMonths = function(months, years) {
        return months + years !== 0;
    };

    /**
     ******************************************
     * Page Related
     ******************************************
     */

    $scope.$watch('pageData.typeClicked', function(type, old) {
        var height = null;
        var wait;
        var scrollTopPx;

        if (!type && !old) return;

        if (!type && old) {
            if (window.innerWidth >= 768) {
                //scroll back up to top only when not stacked
                scrollTopPx = angular.element('.milestone-page-select').offset().top - 100;
                $("html, body").animate({scrollTop: scrollTopPx}, 200);
            }
        }

        //if milestone detail wasn't already open, it doesn't update for a short bit
        wait = old ? 0 : 30;

        function scrollTop(delay) {
            $timeout(function() {
                var $active;
                $scope.fixHeight();

                $active = angular.element('.milestone-box.active');
                if ($active.length) {
                    scrollTopPx = $active.offset().top - 100;
                    $("html, body").animate({scrollTop: scrollTopPx}, 200);
                }

            }, delay);
        }

        if (type) {
            scrollTop(wait);
            //just in case, some browsers take longer
            scrollTop(70);
        } else {
            $scope.milestoneSelectedHeight = height;
        }

    });
    $scope.fixHeight = function() {
        var height;
        height = angular.element('.milestone-box.active .milestone-body').outerHeight() || 330;
        height += 50;
        height += "px";
        $scope.milestoneSelectedHeight = height;
    };

    /**
     * Determines next page to go to
     *
     * Will also perform post & pre page ops
     *
     * @returns {boolean}
     */
    $scope.goNextPage = function(replace) {
        //get current page, find next item on list, go there
        var page = null;
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);

        if ($scope.$stateParams.type !== $scope.milestone.type) {
            //if type changes, need to reset the default pages, if a controller has it's own
            //it will redirect to there on load
            if ($scope.mod.defaultPages) {
                $scope.mod.defaultPages();
            }
            //clear any extra functions/data from shared milestone obj
            $scope.mod.extra = {};
            pageIndex = 0;
        }
        if ($scope.pages.length > 1 && pageIndex >= $scope.pages.length - 1) {
            //on last page so confirm form
            page = 'confirm';
        } else {

            $scope.postPageOperations($scope.$stateParams.page);

            page = $scope.getNextPage($scope.$stateParams.page);

            if (page !== false) {
                page = $scope.initNextPage(page);
            }

            //abort
            if (page === false) return;

        }

        // if (page === 'confirm' && $scope.mod.action === 'update') {
        //     $scope.mod.submitMilestone();
        // } else {
            $scope.goToPage(page, replace);
        // }
    };
    $scope.postPageOperations = function(page) {
        //page post ops
        switch (page) {
            case 'portfolio-type':
                $scope.mod.initPortfolioType($scope.milestone.extra.portfolio_type);
                break;
            default:
                if ($scope.mod.extra.postPageOps) {
                    $scope.mod.extra.postPageOps($scope.$stateParams.page);
                }
        }
    };
    $scope.getNextPage = function() {
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);
        var page = null;

        //get next page
        if ($scope.mod.extra.getNextPage) {
            page = $scope.mod.extra.getNextPage();
        }
        if (page === null) {
            switch ($scope.$stateParams.page) {
                case 'portfolio-simple-type':
                    switch ($scope.milestone.extra.portfolio_simple_type) {
                        case 'portfolio_basic':
                            page = 'allocation-basic';
                            break;
                        case 'portfolio_glide':
                            $scope.$state.go('base.plans.custom.portfolioplus.core', {msId: $scope.$stateParams.msId});
                            page = false;
                            break;
                        case 'portfolio_custom':
                            $scope.$state.go('base.plans.detail.plan', {pslug: "portfolioplus"});
                            page = false;
                            break;
                    }
                    break;
                case 'allocation-basic':
                    //should have submitted from the page
                    $scope.mod.submitAllocation();
                    page = false;
                    break;
                case 'portfolio-type':
                    switch ($scope.milestone.extra.portfolio_type) {
                        case 'stocks_bonds_cash':
                            page = 'cash-amount';
                            break;
                        case 'stocks_bonds':
                            page = 'portfolios';
                            break;
                        case 'cash':
                            page = 'confirm';
                            // if ($scope.mod.action === 'create') {
                            //     page = 'initial-deposit';
                            // } else if ($scope.mod.action === 'update') {
                            //     page = 'auto-deposit';
                            // }
                            break;
                    }
                    break;
                case 'portfolios':
                    if ($scope.milestone.extra.portfolio_slug === 'core') {
                        page = "allocation-start";
                    } else {
                        //skip next page, go to second
                        page = "portfolio-confirm";
                    }
                    break;
                case 'portfolio-confirm':
                    if ($scope.milestone.type === "build_wealth" || $scope.milestone.type_account) {
                        page = 'checkFunding';
                    } else {
                        page = 'cash-amount-end';
                    }
                    break;
                case 'cash-amount-end':
                    if ($scope.milestone.extra.portfolio_slug === "core") {
                        page = 'allocation-end';
                    } else {
                        //custom portfolioPlus portfolio selected so skip to after 'review-glide'
                        if (!$scope.milestone.allocation.cash_end) {
                            //no ending cash so can skip past 'review-glide'
                            page = $scope.pages[$scope.pages.indexOf('review-glide') + 1];
                        } else {
                            page = 'review-glide';
                        }
                    }
                    break;

                default:
                    break;
            }
        }
        if (typeof page === "number") {
            //adds ability to skip x # of pages
            page = $scope.pages[pageIndex+page];
        }
        if (page === null) {
            page = $scope.pages[pageIndex + 1];
        }

        return page;
    };
    /**
     * Gives a chance for a new page to either initialize itself, or change to a different page
     * @param page
     * @returns {*}
     */
    $scope.initNextPage = function(page) {
        var newPage = page;

        if ($scope.mod.extra.initNextPage) {
            newPage = $scope.mod.extra.initNextPage(page);
        }

        switch (page) {
            case 'checkFunding': //pseudo page to trigger this test when page to direct to is unknown
            case 'initial-deposit':
                // if ($scope.mod.action === "update") {
                //     newPage = "auto-deposit";
                // } else {
                //     newPage = "initial-deposit";
                // }
                break;
        }
        if (newPage !== page) {
            //recursive loop
            newPage = $scope.initNextPage(newPage);
        }
        return newPage;
    };

    /**
     * Handles actual page transition
     * @param page
     * @param replace
     */
    $scope.goToPage = function(page, replace) {
        var type = $scope.$stateParams.type;

        var options = {};
        if ($scope.milestone.type) {
            type = $scope.milestone.type;
        }

        if (replace) {
            options = { location: 'replace'};
        }
        $scope.pageData.navigating = true;
        $scope.$state.go('base.milestone-mod.'+ $scope.mod.action +'.steps', {page: page, type: type}, options);
        // {reload:false, notify:false}
    };

    /**
     * Initialize general page milestone-mod and update/create operations.
     * Slightly different that $scope.initNextPage
     * This one is triggered on the success transition
     * @param page
     */
    $scope.mod.initPage = function(page) {
        if (!page || (typeof $scope.mod.initPage.preCheck == 'function' && !$scope.mod.initPage.preCheck(page))) {
            return;
        }

        var pageIndex = $scope.pages.indexOf(page);
        $scope.pageData.page = page;
        $scope.pageData.last = pageIndex === $scope.pages.length-1;

        if (page === 'select') {
            //on first page
            $scope.pageData.percent = 1;
        } else if ($scope.pages[0] === 'select') {
            //moving to second page, ms type controller not loaded yet
            $scope.pageData.percent = 5;
        } else {
            $scope.pageData.percent = (pageIndex + 1) / $scope.pages.length * 100;
        }

        if (typeof $scope.mod.initPage[$scope.mod.action] === 'function' ) {
            //will call either: $scope.mod.initPage.create(page) || $scope.mod.initPage.update(page)
            $scope.mod.initPage[$scope.mod.action](page);
        }
        switch (page) {
            case 'portfolio-type':
                Milestone.getGlidePortfolioTypeRecommend();
                break;
            case 'review-glide':
                Milestone.retrieveGlideFuture();
                break;
            case 'auto-deposit':
                if ($scope.milestone.type_account) break;

                $scope.pageData.sending = true;
                Milestone.getNewDefaultAutoDeposit().then(function() {
                    return Milestone.changedAutoDeposit();
                }).finally(function() {
                    $scope.pageData.sending = false;
                });
                break;
            case 'auto-deposit-detail':
                var total = 0;
                angular.forEach($scope.milestone.accounts, function(account) {
                    total += account.auto_deposit;
                });
                total = Math.round(total*100)/100;

                if (total !== $scope.milestone.auto_deposit.amount) {
                    angular.forEach($scope.milestone.accounts, function(account) {
                        //does it really need to be set to null? this originated from some really old code,
                        // probably not needed. continue to show prev value
                        // account.auto_deposit = null;
                    });
                }
                break;
        }

    };

    var transitionDeregisterHook = {};
    var transitionTimer = null;
    /**
     * For the sake of preventing going forward in pages after having gone backwards
     */
    transitionDeregisterHook[0] = $scope.$transitions.onBefore({ to: 'base.milestone-mod.**' }, function(trans) {

        var fromPage = trans.params('from').page;
        var toPage = trans.params('to').page;

        if (!$scope.pageData.navigating){ // && toPage !== $scope.pageData.prevPage) {
            //prevent forward history state
            //if someone attempts to go backwards, the new current history state will be duplicated thereby removing
            //all forward history, then moved back to be in the proper state.  If forward is hit, it will just go to
            //the same state and won't change.  This can cause a duplicate in the history only if they try to go
            //forward
            // console.log(fromPage, toPage);
            $timeout.cancel(transitionTimer);
            transitionTimer = $timeout(function() {
                //must be in timer or weird loop if hitting back too quickly
                if (fromPage === toPage) {
                    // console.log('single back');
                    $window.history.back();
                } else {
                    // console.log('dupe state');
                    history.pushState({}, '', $location.$$absUrl);
                    $window.history.back();
                }
            });
        } else {
            $scope.pageData.navigating = false;
        }
    });

    transitionDeregisterHook[1] = $scope.$transitions.onFinish({ to: 'base.milestone-mod.**' }, function(trans) {
        var toPage = trans.params('to').page;
        // $scope.pageData.navigating = true;
        // return $scope.$state.target(trans.to().name, {page:'strategy'});
    });

    transitionDeregisterHook[2] = $scope.$transitions.onSuccess({ to: 'base.milestone-mod.**' }, function(trans) {
        //this won't be called on first load, but will be manually called in update/create controller after
        //they override page stuff
        var toPage = trans.params('to').page;
        $scope.mod.initPage(toPage);
        $scope.pageData.view.footer = true;
    });

    $scope.$on('$destroy', function() {
        angular.forEach(transitionDeregisterHook, function(hook) {
            if (typeof hook === "function") {
                hook();
            }
        });
    });

}]);
